export default {
	title: 'Přehled PS',
	policySubseller: 'Podobchodník',
	anualPremiumView: 'Roční pojistné',
	dealDateView: 'Datum sjednání',
	endDateView: 'Datum ukončení',
	policyPaymentStatus: 'Stav první platby',
	insContrNoView: 'Číslo PS/RS',
	policyStatus: 'Stav PS',
	policyExport: 'Export PS',
	insuranceView: 'Pojištění',
	policyHolderView: 'Pojistník',
	provision: 'Provize',
	resultsSubheader: 'Výsledek vyhledávání',
	startDateView: 'Datum počátku',
	zipCode: 'PSČ',
	carRegNo: 'RZ',
	advancedSearch: 'Rozšířené vyhledávání',
	searchSubordinate: 'Vyhledat podobchodníka',
	clientInfo: 'Informace o klientovi',
	policyInfo: 'Informace o PS',
	policyHolderInfo: 'Informace o správci PS',
	policyValueDateFrom: 'Počátek platnosti od',
	policyValueDateTo: 'Počátek platnosti do',
	policyOpenDateFrom: 'Sjednaní PS od',
	policyOpenDateTo: 'Sjednaní PS do',
	policyFinalDateFrom: 'Ukončení platnosti od',
	policyFinalDateTo: 'Ukončení platnosti do',
	policyValueDateAnnualFrom: 'Výročí počátku od',
	policyValueDateAnnualTo: 'Výročí počátku do',
	policyOpenDateAnnualFrom: 'Výročí sjednání od',
	policyOpenDateAnnualTo: 'Výročí sjednání do',
	policyHolderAnnualBirthDateFrom: 'Den a měsíc narození od',
	policyHolderAnnualBirthDateTo: 'Den a měsíc narození do',
	birthYearFrom: 'Rok narození od',
	birthYearTo: 'Rok narození do',
	firstName: 'Jméno',
	surname: 'Příjmení',
	businessName: 'Název',
	birthDate: 'Datum narození',
	businessIn: 'IČO',
	municipality: 'Obec',
	semaphore: 'Semafor',
	policyNumber: 'Číslo PS',
	rsNumber: 'Číslo RS',
	productDomain: 'Produktová oblast',
	product: 'Produkt',
	policyHolderNumber: 'Získatelské číslo správce',
	sellerLogin: 'Login podobchodníka',
	gcpContractsOnly: 'PS - GČP',
	gpContractsOnly: 'PS - GP',
	frameworkPolicyOnly: 'Rámcové smlouvy',
	activePolicyWoQuotationOnly: 'Sjednané PS',
	withSubordinates: 'Včetně podřízených',
	client: 'Klient',
	noPolicyAdminAvailable: 'Na smlouvě není žádný správce',
	inactivePolicyAdmin: 'Neaktivní obchodník',
	firstPaymentStateSiraelTypeTooltip: 'U smluv ze Sirael nemáme informaci o platbě.',
};
